// @module TavanoTeam.CSExtensions.CSCertCapture.Checkout.View
define('TavanoTeam.CSExtensions.CSCertCapture.Checkout.View'
	, [
		'Wizard.Module'
		, 'TavanoTeam.CSExtensions.CSCertCapture.Model'
		, 'AjaxRequestsKiller'

		, 'SC.Configuration'

		, 'tavanoteam_csextensions_cscertcapture_checkout.tpl'

		, 'Utils'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
	]
	, function (
		WizardModule
		, CertCaptureModel
		, AjaxRequestsKiller

		, Configuration

		, tavanoteam_csextensions_cscertcapture_checkout_tpl

		, Utils
		, Backbone
		, jQuery
		, _
	) {
		'use strict';

		// @class TavanoTeam.CSExtensions.CSCertCapture.Checkout.View @extends WizardModule
		return WizardModule.extend({

			template: tavanoteam_csextensions_cscertcapture_checkout_tpl

			//@property {String} className
			, className: 'TavanoTeam.CSExtensions.CSCertCapture.Checkout.View'

			, initialize: function (options) {
				WizardModule.prototype.initialize.apply(this, arguments);


				this.options = options.wizard;

				this.options.application.getLayout().on('afterAppendView', this.loadCertCaptureScript(), this);

				this.model = options.wizard.model;

				this.profile = options.wizard.profileModel;
			}

			, events:
			{
				'click [name="load-certcapture-btn"]': 'loadAvalaraCertCapture'
			}

			, loadAvalaraCertCapture: function (e) {
				var self = this
					, certModel = new CertCaptureModel()
					, user = this.profile.get('name')
					, entityid = user.substring(0, user.indexOf(" "))
					, divEl = document.getElementById('checkout-certcapture-container');
				// ,	newCertCheckoutView = new NewCertCheckoutView({
				// 		application: self.options.application
				// 	,	token: certModel
				// 	,	model: self.model
				// 	,	profileModel: self.profile
				// 	});

				certModel.fetch({
					data: {
						actionType: 'new_cert'
						, entityId: entityid
					}
					, killerId: AjaxRequestsKiller.getKillerId()
				})
					.done(function (result) {
						self.loadCertCaptureWizard(divEl, result, self.model, self.profile);
						//self.options.application.getLayout().showInModal(newCertCheckoutView);
					})
			}

			, loadCertCaptureWizard: function (divContainer, token, model, profile) {
				var self = this
					, user_address = model.get('addresses')
					, userAddr = this.getDefaultShippingAddress(user_address)
					, userName = profile.get('name')
					, entityId = userName.substring(0, userName.indexOf(" "))
					, countries = Configuration.get('siteSettings.countries');

				GenCert.init(divContainer, {
					edit_purchaser: true
					, ship_zone: self.getStateName(userAddr.country, userAddr.state)
					, token: token.token
				});

				GenCert.setCustomerNumber(entityId);

				//set customer information to autopopulate fields
				// and send it to CertCapture's ecommerce SDK
				GenCert.setCustomerData({
					name: profile.get('type') == 'COMPANY' ? profile.get('companyname') : profile.get('firstname') + " " + profile.get('lastname')
					, address1: userAddr.addr1
					, city: userAddr.city
					, state: self.getStateName(userAddr.country, userAddr.state)
					, country: countries[userAddr.country].name
					, zip: userAddr.zip
					, phone: userAddr.phone
				});

				// show CertCapture's Wizard tool
				GenCert.show();
			}

			, getDefaultShippingAddress: function (addresses) {
				var addressObj = {};

				addresses.map(function (state) {
					if (state.get('defaultshipping') == 'T') {
						addressObj.state = state.get('state');
						addressObj.addr1 = state.get('addr1');
						addressObj.city = state.get('city');
						addressObj.country = state.get('country');
						addressObj.zip = state.get('zip');
						addressObj.phone = state.get('phone');
					}
				});

				return addressObj;
			}

			, getStateName: function (countryCode, stateCode) {
				//Since SCA is returning the State's code instead of the whole name
				//We need to pull up the State's name as this is what is needed by CertCapture
				//to auto populate the state field
				var countries = Configuration.get('siteSettings.countries')
					, stateName = '';

				_.each(countries[countryCode].states, function (state) {
					if (state.code == stateCode) {
						stateName = state.name;
					}
				});

				return stateName;
			}

			, loadCertCaptureScript: function () {
				var script = document.createElement('script')
					, certCaptureScript = Configuration.get("certCapture.scriptURL");

				script.type = "text/javascript";
				script.src = certCaptureScript;

				jQuery("head").append(script);
			}

			, hasNoShippingAddress: function () {
				var addresses = this.model.get('addresses')
					, addressModel = addresses.models
					, hasNoShipAddress = true;

				addressModel.map(function (res) {

					if (res.get('defaultshipping') == 'T') {
						hasNoShipAddress = false;
					}
				});

				return hasNoShipAddress;
			}

			//@method getContext @return TavanoTeam.CSExtensions.CSCertCapture.Checkout.View.Context
			, getContext: function getContext() {
				//@class TavanoTeam.CSExtensions.CSCertCapture.Checkout.View.Context
				return {
					noShipAddress: this.hasNoShippingAddress()
					, taxChargeMessage: Configuration.get("certCapture.taxChargeMessage")
				};
			}
		});
	});
